import { lazy } from "react";

const FollowUpTypes = lazy(() =>
  import("../CRM/FollowUpType/FollowUpTypes")
);
const InquerySources = lazy(() =>
  import("../CRM/InqSrcType/InquerySources")
);
const Inquiries = lazy(() => import("../CRM/Inquery/Inquiries"));
const AddEditInquiry = lazy(() =>
  import("../CRM/Inquery/AddEditInquiry")
);
const ViewInquiry = lazy(() => import("../CRM/Inquery/ViewInquiry"));

export const crmRoutes = (access, settings) => {
  if (!settings?.fiscalYearId) return [];

  const routes = [];

  if (access?.inqueryAccess) {
    routes.push(
      { path: "/inquiries", element: Inquiries, title: "inquiries" },
      { path: "/view_inquiry/:id", element: ViewInquiry, title: "viewInquiry" },
    );
    if (access?.inquery?.edit) {
      routes.push({ path: "/inquiry_form/:id", element: AddEditInquiry, title: "editInquiry" });
    }
    if (access?.inquery?.create) {
      routes.push({ path: "/inquiry_form", element: AddEditInquiry, title: "addInquiry" });
    }
  }

  if (access.followUpTypeAccess) {
    routes.push({ path: "/fullow_up_types", element: FollowUpTypes, title: "followUpTypes" });
  }
  if (access.inquerySourceAccess) {
    routes.push({ path: "/inquery_sources", element: InquerySources, title: "inquirySources" });
  }

  return routes;
};
